import {
  STAGE_REVIEW
} from '../../../dictionaries/Engagement.dic';
import {
  NOT
} from '../../Boolean.lib';

/**
 * Checks if all engagements for a given candidate are in the review stage.
 *
 * @function evalCandidateEngsAllReview
 * @param {Object} params - Function parameters.
 * @param {string} params.candidateId - The candidate's unique identifier.
 * @param {Object[]} [params.engagements=[]] - List of engagement objects to evaluate.
 * @returns {boolean} True if all engagements for the candidate are in the review stage; false otherwise.
 *
 * @description
 * - Filters the engagements list for the specified candidate ID.
 * - Returns `false` immediately if the candidate has no engagements.
 * - Uses `Array.prototype.every` to verify that each engagement's `stage` equals `STAGE_REVIEW`.
 * - Intended to be used in filters, mappings, or validation checks over candidate engagement data.
 */
export default function evalCandidateEngsAllReview({
  candidateId = '',
  engagements = [],
}) {

  // Filter engagements for the candidate
  const candidateEngs = engagements.filter(
    (engagement) => (engagement.candidateId === candidateId)
  );

  // Return false if no engagements for this candidate
  if (NOT(candidateEngs.length)) return false;

  // Check if all engagements are in the review stage
  const allReviewed = candidateEngs.every(
    (engagement) => (engagement.stage === STAGE_REVIEW)
  );

  return allReviewed;

}
